import { useFeatureFlagEnabled } from 'posthog-js/react'

// The same key will gate the backend's auto-approve-vs-pending branch (WP-9662). Nothing pins
// the two together yet, so rename with care.
export const SHARED_DICTIONARY_APPROVAL_FLAG = 'shared-dictionary-approval'

// Tri-state by design: callers default `undefined` themselves. Folding it to false here would
// bounce a deep link out to /app/home before PostHog answers.
export const useSharedDictionaryApprovalEnabled = (): boolean | undefined =>
  useFeatureFlagEnabled(SHARED_DICTIONARY_APPROVAL_FLAG)
